import type { AxiosInstance } from 'axios'
import type { Constructor, Keys, LegoConstructor, MemoType } from 'common/types'

type HttpClientLike = {
  instance: AxiosInstance
  setSecurityData: (data: unknown) => void
}

type ClientsMap = Record<string, Constructor>

export function constructClientDispenser<
  Clients extends ClientsMap,
  HttpClientConstructor extends LegoConstructor<undefined, HttpClientLike>,
>(clients: Clients, httpClientConstructor: HttpClientConstructor, axiosInstance: AxiosInstance) {
  type ClientsType = Keys<Clients>
  type Client<T extends ClientsType> = InstanceType<Clients[T]>

  const httpClient = new httpClientConstructor()
  httpClient.instance = axiosInstance
  const memo: MemoType<Clients> = {}

  function assertIsCorrectClient<Target extends ClientsType, Candidate>(
    value: Candidate,
    target: Target,
  ): asserts value is Client<Target> {
    if (!(value instanceof clients[target])) {
      throw new Error()
    }
  }

  return function <T extends ClientsType>(clientType: T): Client<T> {
    memo[clientType] ??= new clients[clientType](httpClient)
    const toReturn = memo[clientType]
    assertIsCorrectClient(toReturn, clientType)
    // доверия к компилятору typescript больше, чем к eslint
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return toReturn
  }
}
